export default {
  LOAD_VENUE_MENU: "LOAD_VENUE_MENU",
  LOAD_LUNCH_MENU: "LOAD_LUNCH_MENU",
  ADD_NEW_LUNCH: "ADD_NEW_LUNCH",
  LOAD_CLIENTS: "LOAD_CLIENTS",
  AUTH_SUCCESS: "AUTH_SUCCESS",
  UPDATE_WELCOME: "UPDATE_WELCOME",
  GIFTS_LOADED: "GIFTS_LOADED",
  UPDATE_GIFT_POSITIONS: "UPDATE_GIFT_POSITIONS",
  UPDATE_MESSAGE: "UPDATE_MESSAGE",
  TOGGLE_GIFTS_AVAILABLE: "TOGGLE_GIFTS_AVAILABLE",
  LOAD_REVIEWS: "LOAD_REVIEWS",
  SET_NEW_ADMIN: "SET_NEW_ADMIN",
  LOAD_SUPPORT: "LOAD_SUPPORT",
  UPDATE_SCHEDULE: "UPDATE_SCHEDULE",
  LOAD_CHATS: "LOAD_CHATS",
  UPDATE_ORDER_LIST: "UPDATE_ORDER_LIST",
  LOAD_FULL_MENU: "LOAD_FULL_MENU",
  LOAD_MAILINGS: "LOAD_MAILINGS",
  LOAD_DASHBOARD_STATS: "LOAD_DASHBOARD_STATS",
  LOAD_DASHBOARD_FEEDBACKS: "LOAD_DASHBOARD_FEEDBACKS",
  LOAD_DASHBOARD_EVENTS: "LOAD_DASHBOARD_EVENTS",
  UPDATE_LUNCH_OFFERS: "UPDATE_LUNCH_OFFERS",
  LOAD_CORP_MENUS: "LOAD_CORP_MENUS",
  LOAD_CORP_MENU: "LOAD_CORP_MENU",
  LOAD_TAGS: "LOAD_TAGS",
  SET_PACKING_COST: "SET_PACKING_COST",
  SET_DELIVERY_SETTINGS: "SET_DELIVERY_SETTINGS",
  SET_CURRENCY: "SET_CURRENCY",
  LOGOUT: "LOGOUT",
  LOAD_STARS_ITEMS: "LOAD_STARS_ITEMS",
  UPDATE_PAYMENT_SETTINGS: "UPDATE_PAYMENT_SETTINGS",
  LOAD_VENUE_INFO: "LOAD_VENUE_INFO",
  LOAD_STARS_PROMOCODE: "LOAD_STARS_PROMOCODE",
  UPDATE_REGISTER_STEPS: "UPDATE_REGISTER_STEPS",
  LOAD_ITEM_FEEDBACKS_RATING: "LOAD_ITEM_FEEDBACKS_RATING",

  /* venue feedbacks */
  LOAD_VENUE_FEEDBACKS: "LOAD_VENUE_FEEDBACKS",
};



// WEBPACK FOOTER //
// ./src/actionTypes.js